export default __webpack_public_path__ + "static/media/shape-1.cd2c960d.png";